import * as yup from "yup";
import { FilterViewModel } from "api/factories/ulits.factory";

export type SchedulerExceptionForm = Readonly<{
    id?: Readonly<string>;
    name: string;
    filters: FilterViewModel[];
    materialRequest: boolean;
    frequency: FrequencyType;
    lookHeadDays: string;
    day?: string;
    time: string;
    template: string;
    status: string;
}>;

export type FrequencyType = "EVERY_DAY" | "EVERY_WEEK";

export const exceptionDefaultValues: SchedulerExceptionForm = {
    time: "12:00",
    frequency: "EVERY_DAY",
    status: "",
    template: "",
    day: "",
    name: "",
    lookHeadDays: "7",
    filters: [{ name: "", operator: "", logicalOperator: "And" }],
    materialRequest: false,
};

export const emailExceptionsSchema = yup.object().shape({
    name: yup.string().required(),
    materialRequest: yup.boolean(),
    status: yup.string().when("template", {
        is: (template: string) => template === "",
        then: yup.string().required("Status is required"),
        otherwise: yup.string(),
    }),
    frequency: yup.string().required(),
    day: yup.string().when("frequency", {
        is: "EVERY_WEEK",
        then: yup.string().required(),
    }),
    time: yup.string().required(),
    template: yup.string(),
    lookHeadDays: yup
        .string()
        // eslint-disable-next-line
        .min(1, "Field must be greater than or equal to ${min}")
        .required("Look head days is required"),
    filters: yup
        .array()
        .min(1)
        .of(
            yup.object().shape({
                name: yup.string().required("Field is required"),
                operator: yup.string().required("Operator is required"),
                value: yup
                    .object()
                    .nullable()
                    .default({})
                    .shape({
                        name: yup.string(),
                        value: yup.string(),
                    })
                    .required("Value is required"),
            })
        ),
});
